import { useEffect, useState } from 'react';
import { useLDFlag } from 'src/contexts/LaunchDarklyContext/LaunchDarklyContext';

// Shared release gate for all languages with Fern examples.
export const FERN_SDK_FLAG = 'docs-fern-sdk';

export function useFernSdkEnabled(): boolean {
  const flag = useLDFlag(FERN_SDK_FLAG, false);
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  // Static HTML and the first hydration render must both show legacy examples.
  return hasMounted && flag === true;
}
